import React from 'react';
import Alert from './Alert';
import AlertProps from './AlertProps';
import styles from './pagealert.module.scss';

const PageAlert = (props: AlertProps) => {
  return (
    <div className={styles.pageAlert}>
      <Alert {...props} />
    </div>
  )
}

export default PageAlert;
